@let loggedUser = user();

@if (loggedUser) {
  <nav
    class="flex flex-col gap-y-5 md:gap-y-[104px] px-6 py-4 rounded-lg print:hidden"
    [class.not-expanded]="!expanded()"
    [class.expanded]="expanded()"
  >
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-x-8">
        <a [routerLink]="['/dashboard']">
          <ui-kit-logo [variant]="'light'" />
        </a>
        <ul class="hidden md:flex gap-x-4">
          @for (item of menu(); track $index) {
            <li class="text-sm" *authRole="item.roles">
              <a [routerLink]="item.url" class="text-[#D4D7D8] font-medium menu-link" [routerLinkActive]="'active'">
                {{ item.label | transloco }}
              </a>
            </li>
          }
        </ul>
      </div>

      <div class="flex items-center gap-x-[10px]">
        <app-user-membership-recap class="hidden lg:block" *authRole="[Role.USER]" />

        <app-burger-menu (click)="toggleMobileMenu()" />

        <app-user-avatar [user]="loggedUser" (logout)="logout()" />
      </div>
    </div>

    <div
      class="md:hidden mobile-menu px-6 py-4 bg-bunker-950 w-full shadow-sm rounded-md"
      [class.block]="showMobileMenu()"
      [class.hidden]="!showMobileMenu()"
    >
      <ul class="flex flex-col gap-y-3">
        @for (item of menu(); track $index) {
          <li class="text-md" *authRole="item.roles">
            <a
              [routerLink]="item.url"
              class="text-typography-muted font-medium menu-link"
              [routerLinkActive]="'active'"
              (click)="toggleMobileMenu()"
            >
              {{ item.label | transloco }}
            </a>
          </li>
        }
      </ul>

      <app-user-membership-recap *authRole="[Role.USER]" />
    </div>

    <app-welcome-banner [firstName]="firstName()" [class.hidden]="!expanded()" />
  </nav>
}
